import { Spinner } from 'components/core';
import { LocalStorageManager } from 'services/storage/LocalStorageManager';
import React, {
  PropsWithChildren,
  ReactElement,
  useEffect,
  useState,
} from 'react';
import { useProjectId } from 'store/project';
import { SelectProject } from 'views/projects/selection';
import {
  ProjectLoadingGateProps,
  WithProjectLoading,
} from '../withProjectLoader';

const RESTORE_PROJECT_TIMEOUT_MS = 5000;

const WithSelectProject: React.FC<
  PropsWithChildren<ProjectLoadingGateProps>
> = ({ children, showsContentOnFailure }) => {
  const projectId = useProjectId();
  const [restoreTimedOut, setRestoreTimedOut] = useState(false);

  useEffect(() => {
    if (projectId || !LocalStorageManager.wasProjectSelected()) {
      setRestoreTimedOut(false);
      return;
    }

    const timeout = setTimeout(() => {
      setRestoreTimedOut(true);
    }, RESTORE_PROJECT_TIMEOUT_MS);

    return () => clearTimeout(timeout);
  }, [projectId]);

  if (projectId) {
    return (
      <WithProjectLoading showsContentOnFailure={showsContentOnFailure}>
        {children}
      </WithProjectLoading>
    );
  }

  if (LocalStorageManager.wasProjectSelected() && !restoreTimedOut) {
    return <Spinner reason="Restoring selected project after refresh" />;
  }

  return <SelectProject />;
};

const withSelectProject =
  (Component: React.ComponentType<any>) =>
  ({ ...props }): ReactElement => (
    <WithSelectProject>
      <Component {...props} />
    </WithSelectProject>
  );

export { WithSelectProject, withSelectProject };
